import { render } from "./kubeovn.io.vlan.vue?vue&type=template&id=0601b1c4"
import script from "./kubeovn.io.vlan.vue?vue&type=script&lang=js"
export * from "./kubeovn.io.vlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__